import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Gw3WebGuidService {

  constructor() { }
}
